export enum GraphicsType {
    JPG,
    PNG,
    SVG,
    WEBP,
}
